import React from 'react';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import StepNavigationComponent from '../../../components/shared_components/tool/StepNavigationComponent';
import SavingsGraphComponent from '../../../components/tool/step4/SavingsGraphComponent';
import SavingsComponent from '../../../components/tool/step4/SavingsComponent';
import AssumptionsLoanpartComponent from '../../../components/tool/step4/AssumptionsLoanpartComponent';
import SavingsOverviewComponent from '../../../components/tool/step4/SavingsOverviewComponent';
import LoaderComponent from '../../../components/shared_components/LoaderComponent';
import ErrorAlertComponent from '../../../components/shared_components/ErrorAlertComponent';
import PrimaryButton from '../../../components/shared_components/buttons/PrimaryButtonComponent';
import { getItemFromLocalStorage } from '../../../stores/tool/storage/storage';

@withRouter
@observer
class SavingsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.startDownloadPdf = this.startDownloadPdf.bind(this);
    this.navigateBack = this.navigateBack.bind(this);
  }

  navigateBack() {
    this.props.history.push('step-2');
  }

  startDownloadPdf(e) {
    e.preventDefault();
    e.stopPropagation();
    const { calculationForm } = this.props.ToolOverviewData;
    this.props.SavingsData.setTextDownloadReport('Downloaden...');
    this.props.SavingsData.downloadPdf(calculationForm);
  }

  render() {
    let series = this.props.SavingsData.termInterestSavingsSeries;
    if (getItemFromLocalStorage('LooptijdRenteTermInterestSavingsSeries')) {
      series = getItemFromLocalStorage('LooptijdRenteTermInterestSavingsSeries');
    }

    const {
      loanpartsResult,
      textDownloadReport,
    } = this.props.SavingsData;
    let loanpartsResultCopy = Object.assign({}, loanpartsResult);

    if (_.isEmpty(loanpartsResultCopy)) {
      loanpartsResultCopy = getItemFromLocalStorage('LooptijdRenteLoanpartsResult');
    }

    const {
      errorFields,
      responseError,
    } = this.props.ValidationData;

    /* Show SearchAdvisorButton when user did not select a label with looptijdrente */
    let { toolSettings } = this.props.ToolSettingData;

    if (!_.isEmpty(getItemFromLocalStorage('LooptijdRenteToolSettings'))
      && (_.isEmpty(toolSettings)
        || Object.values(toolSettings).some(prop => _.isEmpty(prop)))) {
      toolSettings = getItemFromLocalStorage('LooptijdRenteToolSettings');
    }

    const {
      advisorSearchUrl,
      colorChart,
      colorBackgroundChart,
      colorXAxisChart,
    } = toolSettings;

    const searchAdvisorButton = (
      <PrimaryButton
        onClickHandler={() => { window.open(advisorSearchUrl, '_blank'); }}
        classNames="search-button"
        text="Zoek adviseur"
        show={!_.isEmpty(advisorSearchUrl)}
      />
    );

    const showPdfDownloadButton = true;

    /* Show savingsComponent when user did select a label with looptijdrente */
    const savingsComponent = (
      <div>
        <div className="columns medium-84 tool-sub-header">
          <h2>U heeft een hypotheek op basis van looptijdrente gekozen.</h2>
          <p>hierdoor kunt u waarschijnlijk besparen ten opzichte van een hypotheek zonder looptijdrente. In de
             (voorbeeld-) berekeningen en vergelijkingen wordt het verschil in rentelasten weergegeven.
             Hierbij worden de aflossing en eventuele overlijdensrisicopremie buiten beschouwing gelaten.</p>
          <p>De aflossing komt wel terug in het maandlasten overzicht wanneer er een berekening wordt gemaakt.</p>
        </div>

        <div className="columns medium-84 savings-container__savings-component">
          <SavingsGraphComponent
            advisorSearchUrl={`#${advisorSearchUrl}`}
            colorChart={`#${colorChart}`}
            colorBackgroundChart={`#${colorBackgroundChart}`}
            colorXAxisChart={colorXAxisChart}
            classNames="medium-84 large-42 columns"
            show={series[1].data[0] > 0}
            termInterestSavingsSeries={series}
          />

          <SavingsComponent
            showPdfDownloadButton={showPdfDownloadButton}
            textDownloadReport={textDownloadReport}
            startDownloadPdf={this.startDownloadPdf}
            series={series}
            show={series[1].data[0] > 0}
            classNames="savings-container__savings medium-84 large-42 columns"
          />
        </div>
      </div>
    );

    const labelWithoutLooptijdrente = series[0].data[1] === 0;

    return (
      <div className="savings-container">
        <div>
          <StepNavigationComponent
            classNames="medium-36 columns float-right"
          />
          <ErrorAlertComponent
            show={responseError}
            responseError={responseError}
            errorFields={errorFields}
          />
        </div>

        {!labelWithoutLooptijdrente && savingsComponent}

        <div className="columns center-block">
          <LoaderComponent
            show={series && series[1].data[0] === 0}
          />
        </div>

        <div className="medium-84">
          <hr className="savings-container__horizontal-rule" />
        </div>

        <div className="columns medium-84 tool-sub-header">
          <h2>Uitgangspunten voor deze berekening</h2>
        </div>

        <div className="columns medium-84 savings-container__assumptions-component">
          <AssumptionsLoanpartComponent />
        </div>

        <div className="medium-84">
          <SavingsOverviewComponent
            loanpartsResult={loanpartsResultCopy}
            show={!_.isEmpty(loanpartsResultCopy)}
          />

          <div className="columns center-block">
            <LoaderComponent
              show={series && series[1].data[0] === 0}
            />
          </div>
        </div>

        <div className="full-row columns">
          <div className={'savings-container__navigate-back'}>
            <PrimaryButton
              text="Terug"
              onClickHandler={this.navigateBack}
              show
            />
          </div>

          <div className="savings-container__button-group__bottom">
            <PrimaryButton
              show={showPdfDownloadButton}
              onClickHandler={this.startDownloadPdf}
              disabled={!_.isEmpty(textDownloadReport)}
              href="#"
              text={textDownloadReport || 'Download rapport'}
            />
            {searchAdvisorButton}
          </div>

        </div>
      </div>
    );
  }
}

SavingsContainer.propTypes = {
  ToolOverviewData: PropTypes.shape({
    calculationForm: PropTypes.shape({}),
  }),
  ValidationData: PropTypes.shape({
    errorFields: PropTypes.arrayOf(PropTypes.shape({})),
    responseError: PropTypes.string,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  SavingsData: PropTypes.shape({
    loanpartsResult: PropTypes.shape({}),
    termInterestSavingsSeries: PropTypes.arrayOf(PropTypes.shape({})),
    downloadPdf: PropTypes.func,
    setTextDownloadReport: PropTypes.func,
    textDownloadReport: PropTypes.string,
  }),
  ToolSettingData: PropTypes.shape({
    toolSettings: PropTypes.shape({
      advisorSearchUrl: PropTypes.string,
      colorChart: PropTypes.string,
      colorBackgroundChart: PropTypes.string,
      colorXAxisChart: PropTypes.string,
    }),
  }).isRequired,
};

SavingsContainer.defaultProps = {
  ToolOverviewData: {
    calculationForm: {},
  },
  ValidationData: {},
  history: {
    push: () => {},
  },
  SavingsData: {
    loanpartsResult: [],
    termInterestSavingsSeries: [],
    downloadPdf: () => {},
    setTextDownloadReport: () => {},
    textDownloadReport: '',
  },
};

export default inject(
  'ValidationData',
  'ToolOverviewData',
  'SavingsData',
  'ToolSettingData',
)(SavingsContainer);
